import { styled } from '@material-ui/core';

export const HiddenInput = styled('input')({
    display: 'none',
});
